import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { HomeComponent } from './components/home/home.component';
import { NegociacionComponent } from './pages/negociacion/negociacion.component';
import { GestionClienteComponent } from './pages/gestion-cliente/gestion-cliente.component';
import { CargaInfoComponent } from './pages/carga-info/carga-info.component';
import { ReportesComponent } from './pages/reportes/reportes.component';
import { EnvioMailMasivoComponent } from './pages/envio-mail-masivo/envio-mail-masivo.component';
import { UsuariosComponent } from './pages/usuarios/usuarios.component';
import { AprobacionesComponent } from './pages/aprobaciones/aprobaciones.component';
import { AcuerdosComponent } from './pages/acuerdos/acuerdos.component';
import { OperacionesExtinguidasComponent } from './pages/operaciones-extinguidas/operaciones-extinguidas.component';



const routes: Routes = [

  { path: 'login', component: LoginComponent },
  { path: 'inicio', component: HomeComponent },
  { path: 'carga-info', component: CargaInfoComponent },
  { path: 'reportes', component: ReportesComponent },
  { path: 'lista-clientes-negociacion', component: NegociacionComponent },
  { path: 'gestion-cliente/:id', component: GestionClienteComponent },
  { path: 'gestion-cliente-libre/:id', component: GestionClienteComponent },
  { path: 'envio-mail-masivo', component: EnvioMailMasivoComponent },
  { path: 'usuarios', component: UsuariosComponent },
  { path: 'aprobaciones', component: AprobacionesComponent },
  { path: 'acuerdos', component: AcuerdosComponent },
  { path: 'op-extinguidas', component: OperacionesExtinguidasComponent },
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: '**', component: NotFoundComponent },

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
